import {computed, Injectable, signal} from '@angular/core';
import {DLPageTypeEnum} from '../../../enums/DataLayerEnums';

@Injectable({
  providedIn: 'root',
})
export class SearchWidgetV3StateService {
  public freeSearchFieldValue = signal<string>('');
  public placesFieldValue = signal<string>('');
  public newFreeSearchFieldValue = signal<string>('');
  public newPlacesFieldValue = signal<string>('');

  public colapsedSearchFieldValue = computed<string>(() => {
    const valuesArray = [];
    if (this.freeSearchFieldValue()) {
      valuesArray.push(this.freeSearchFieldValue());
    }
    if (this.placesFieldValue()) {
      valuesArray.push(this.placesFieldValue());
    }
    return valuesArray.join(' ');
  });
  public isSearchWidgetExpanded = signal<boolean>(false);
  public pageType = signal<DLPageTypeEnum>(null);
  public mainCareProviderTypeId = signal<number>(null);
  public inferredCareProviderTypeAreaId = signal<number>(null);
  public inferredCategoryTypeId = signal<number>(null);
  public isSubmitButtonActive = computed<boolean>(() => true);

  public mobilePlacesPanelOpen = signal<boolean>(false);
  public mobileCategoriesPanelOpen = signal<boolean>(false);

  public desktopPlacesPanelOpen = signal<boolean>(false);
  public desktopCategoriesPanelOpen = signal<boolean>(false);
  public isDesktopSuggestionsPanelOpen = signal<boolean>(true);

  public isLocationSearchVisible = signal<boolean>(false);
  public isLocationLoading = signal<boolean>(false);
  public locationGetErrorMessage = signal<string>(null);

  public shouldFocusPlacesField = signal<boolean>(false);

  public updateNewFreeSearchFieldValue(value: string): void {
    this.newFreeSearchFieldValue.set(value);
  }

  public updateNewPlacesFieldValue(value: string): void {
    this.newPlacesFieldValue.set(value);
  }

  public updateFreeSearchFieldValue(value: string): void {
    this.freeSearchFieldValue.set(value);
  }

  public updatePlacesFieldValue(value: string): void {
    this.placesFieldValue.set(value);
  }

  public updateIsSearchWidgetExpanded(value: boolean): void {
    this.isSearchWidgetExpanded.set(value);
  }

  public updateShouldFocusPlacesField(value: boolean): void {
    this.shouldFocusPlacesField.set(value);
  }

  public updateMobileCategoriesPanelOpenValue(value: boolean): void {
    this.mobileCategoriesPanelOpen.set(value);
  }

  public updateMobilePlacesPanelOpenValue(value: boolean): void {
    this.mobilePlacesPanelOpen.set(value);
  }

  public updateDesktopCategoriesPanelOpenValue(value: boolean): void {
    this.desktopCategoriesPanelOpen.set(value);
  }

  public updateDesktopPlacesPanelOpenValue(value: boolean): void {
    this.desktopPlacesPanelOpen.set(value);
  }

  public updateIsDesktopSuggestionsPanelOpen(value: boolean): void {
    this.isDesktopSuggestionsPanelOpen.set(value);
  }

  public updateIsLocationSearchVisible(value: boolean): void {
    this.isLocationSearchVisible.set(value);
  }

  public updateIsLocationLoading(value: boolean): void {
    this.isLocationLoading.set(value);
  }

  public updateLocationGetErrorMessage(value: string): void {
    this.locationGetErrorMessage.set(value);
  }
}
